// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

Vue.config.productionTip = false

import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);

import axios from 'axios'
Vue.prototype.axios = axios

import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

import qs from 'qs'
Vue.prototype.qs = qs

import moment from "moment";
Vue.prototype.$moment = moment;

import wx from 'weixin-jsapi'

import Global from './components/Global/global.vue'

// Vue.prototype.apiUrl = Global.apiUrl;
console.log(process.env.API_ROOT);
axios.defaults.baseURL = process.env.API_ROOT
// axios.defaults.baseURL = 'https://www.chim.org.cn'

import './assets/font/iconfont.css'

import VConsole from 'vconsole';
// 判断是否是pc设备
const isPc = () => {
    const userAgentInfo = navigator.userAgent;
    const Agents = ["Android", "iPhone",
        "SymbianOS", "Windows Phone",
        "iPad", "iPod"];
    let flag = true;
    for (let v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
            flag = false;
            break;
        }
    }
    return flag;
}
//如果不是生产环境并且不是pc设备那么就显示调试
if (process.env.API_ROOT != "https://www.chim.org.cn/" && !isPc()) {
    // console.log(process.env.NODE_ENV);
    //const vConsole = new VConsole();
}


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js